import { render } from "./GlobalHeader.vue?vue&type=template&id=58fd772f"
import script from "./GlobalHeader.vue?vue&type=script&lang=js"
export * from "./GlobalHeader.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&id=58fd772f&lang=scss&module=s"
cssModules["s"] = style0
import "./GlobalHeader.vue?vue&type=style&index=1&id=58fd772f&lang=scss"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__